import * as React from "react";
const Note = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M28.8803 13.9202L27.5737 19.4935C26.4537 24.3068 24.2403 26.2535 20.0803 25.8535C19.4137 25.8002 18.6937 25.6802 17.9203 25.4935L15.6803 24.9602C10.1203 23.6402 8.40032 20.8935 9.70699 15.3202L11.0137 9.73351C11.2803 8.60017 11.6003 7.61351 12.0003 6.80017C13.5603 3.57351 16.2137 2.70684 20.667 3.76017L22.8937 4.28017C28.4803 5.58684 30.187 8.34684 28.8803 13.9202Z"
        fill="#344054"
      />
      <path
        d="M28.8803 13.9202L27.5737 19.4935C26.4537 24.3068 24.2403 26.2535 20.0803 25.8535C19.4137 25.8002 18.6937 25.6802 17.9203 25.4935L15.6803 24.9602C10.1203 23.6402 8.40032 20.8935 9.70699 15.3202L11.0137 9.73351C11.2803 8.60017 11.6003 7.61351 12.0003 6.80017C13.5603 3.57351 16.2137 2.70684 20.667 3.76017L22.8937 4.28017C28.4803 5.58684 30.187 8.34684 28.8803 13.9202Z"
        fill="url(#paint0_linear_3639_300852)"
      />
    </g>
    <path
      d="M20.0802 25.8531C19.2535 26.4131 18.2135 26.8798 16.9469 27.2931L14.8402 27.9865C9.54688 29.6931 6.76021 28.2665 5.04021 22.9731L3.33354 17.7065C1.62688 12.4131 3.04021 9.61314 8.33354 7.90647L10.4402 7.21314C10.9869 7.0398 11.5069 6.89314 12.0002 6.7998C11.6002 7.61314 11.2802 8.59981 11.0135 9.73314L9.70688 15.3198C8.40021 20.8931 10.1202 23.6398 15.6802 24.9598L17.9202 25.4931C18.6935 25.6798 19.4135 25.7998 20.0802 25.8531Z"
      fill="#344054"
    />
    <path
      d="M20.0802 25.8531C19.2535 26.4131 18.2135 26.8798 16.9469 27.2931L14.8402 27.9865C9.54688 29.6931 6.76021 28.2665 5.04021 22.9731L3.33354 17.7065C1.62688 12.4131 3.04021 9.61314 8.33354 7.90647L10.4402 7.21314C10.9869 7.0398 11.5069 6.89314 12.0002 6.7998C11.6002 7.61314 11.2802 8.59981 11.0135 9.73314L9.70688 15.3198C8.40021 20.8931 10.1202 23.6398 15.6802 24.9598L17.9202 25.4931C18.6935 25.6798 19.4135 25.7998 20.0802 25.8531Z"
      fill="url(#paint1_linear_3639_300852)"
    />
    <path
      d="M23.3203 14.0135C23.2403 14.0135 23.1603 14.0002 23.067 13.9869L16.6003 12.3469C16.067 12.2135 15.747 11.6669 15.8803 11.1335C16.0137 10.6002 16.5603 10.2802 17.0937 10.4135L23.5603 12.0535C24.0937 12.1869 24.4137 12.7335 24.2803 13.2669C24.1737 13.7069 23.7603 14.0135 23.3203 14.0135Z"
      fill="#344054"
    />
    <path
      d="M23.3203 14.0135C23.2403 14.0135 23.1603 14.0002 23.067 13.9869L16.6003 12.3469C16.067 12.2135 15.747 11.6669 15.8803 11.1335C16.0137 10.6002 16.5603 10.2802 17.0937 10.4135L23.5603 12.0535C24.0937 12.1869 24.4137 12.7335 24.2803 13.2669C24.1737 13.7069 23.7603 14.0135 23.3203 14.0135Z"
      fill="url(#paint2_linear_3639_300852)"
    />
    <path
      d="M19.4136 18.5199C19.3336 18.5199 19.2536 18.5065 19.1603 18.4932L15.2803 17.5065C14.7469 17.3732 14.4269 16.8265 14.5603 16.2932C14.6936 15.7599 15.2403 15.4399 15.7736 15.5732L19.6536 16.5599C20.1869 16.6932 20.5069 17.2399 20.3736 17.7732C20.2669 18.2265 19.8669 18.5199 19.4136 18.5199Z"
      fill="#344054"
    />
    <path
      d="M19.4136 18.5199C19.3336 18.5199 19.2536 18.5065 19.1603 18.4932L15.2803 17.5065C14.7469 17.3732 14.4269 16.8265 14.5603 16.2932C14.6936 15.7599 15.2403 15.4399 15.7736 15.5732L19.6536 16.5599C20.1869 16.6932 20.5069 17.2399 20.3736 17.7732C20.2669 18.2265 19.8669 18.5199 19.4136 18.5199Z"
      fill="url(#paint3_linear_3639_300852)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300852"
        x1={19.2943}
        y1={25.9043}
        x2={19.2943}
        y2={3.33545}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84FAB0" />
        <stop offset={1} stopColor="#ACCBEE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300852"
        x1={11.3642}
        y1={28.6695}
        x2={11.3642}
        y2={6.7998}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84FAB0" />
        <stop offset={1} stopColor="#ACCBEE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300852"
        x1={20.0803}
        y1={14.0135}
        x2={20.0803}
        y2={10.3833}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84FAB0" />
        <stop offset={1} stopColor="#ACCBEE" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300852"
        x1={17.4669}
        y1={18.5199}
        x2={17.4669}
        y2={15.543}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84FAB0" />
        <stop offset={1} stopColor="#ACCBEE" />
      </linearGradient>
    </defs>
  </svg>
);
export default Note;
